export const getTwoLastSymbolsOfYear = (year: number) => {
  return String(year).slice(-2)
}
